import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Chat: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--chat')}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g
      id="Chat-Icon-32x32"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" fill="#000000" fillRule="nonzero">
        <g id="Chat">
          <path d="M28,5.96643066 L28,19.9870605 L25,19.9864307 L25,23.5 L14.5,23.5 L8.5,28 L8.50417122,23.5 L5,23.5 L5,9 L8,8.99943066 L8,5.96643066 L28,5.96643066 Z M23.5,10.5 L6.5,10.5 L6.5,22 L10.0055623,22 L10.0027834,24.9979125 L14,22 L23.5,22 L23.5,10.5 Z M26.5,7.46643066 L9.5,7.46643066 L9.5,8.99943066 L25,9 L25,18.4864307 L26.5,18.4870605 L26.5,7.46643066 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default Chat;
